/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { UpdateUserStatusRequestDto } from '../models/UpdateUserStatusRequestDto';
import type { UserDetailResponseDto } from '../models/UserDetailResponseDto';
import type { UserRequestDto } from '../models/UserRequestDto';
import type { UserResponseDto } from '../models/UserResponseDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class UserControllerService {

    /**
     * Получение пользователя по id
     * @param id
     * @returns UserDetailResponseDto Пользователь успешно получен
     * @throws ApiError
     */
    public static findUserById(
        id: number,
    ): CancelablePromise<UserDetailResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/users/{id}',
            path: {
                'id': id,
            },
            errors: {
                404: `Пользователь не найден`,
            },
        });
    }

    /**
     * Обновление пользователя
     * @param id
     * @param requestBody
     * @returns UserDetailResponseDto Пользователь успешно обновлен
     * @throws ApiError
     */
    public static updateUser(
        id: number,
        requestBody: UserRequestDto,
    ): CancelablePromise<UserDetailResponseDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/users/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Некорректные данные`,
                404: `Пользователь не найден`,
            },
        });
    }

    /**
     * Удаление пользователя
     * @param id
     * @returns void
     * @throws ApiError
     */
    public static deleteUser(
        id: number,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/users/{id}',
            path: {
                'id': id,
            },
            errors: {
                404: `Пользователь не найден`,
            },
        });
    }

    /**
     * Поиск пользователей с фильтрами
     * @param email
     * @param status
     * @param company
     * @returns UserResponseDto Пользователи успешно получены
     * @throws ApiError
     */
    public static findUsers(
        email?: string,
        status?: 'ACTIVE' | 'INACTIVE' | 'SUSPENDED' | 'PENDING',
        company?: string,
    ): CancelablePromise<Array<UserResponseDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/users',
            query: {
                'email': email,
                'status': status,
                'company': company,
            },
        });
    }

    /**
     * Создание пользователя
     * @param requestBody
     * @returns UserDetailResponseDto Пользователь успешно создан
     * @throws ApiError
     */
    public static createUser(
        requestBody: UserRequestDto,
    ): CancelablePromise<UserDetailResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/users',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Некорректные данные`,
            },
        });
    }

    /**
     * Обновление статуса пользователя
     * @param id
     * @param requestBody
     * @returns UserDetailResponseDto Статус пользователя успешно обновлен
     * @throws ApiError
     */
    public static updateUserStatus(
        id: number,
        requestBody: UpdateUserStatusRequestDto,
    ): CancelablePromise<UserDetailResponseDto> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/users/{id}/status',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Некорректный статус`,
                404: `Пользователь не найден`,
            },
        });
    }

    /**
     * Получение пользователя по Keycloak userId
     * @param keycloakUserId
     * @returns UserDetailResponseDto Пользователь успешно получен
     * @throws ApiError
     */
    public static findUserByKeycloakUserId(
        keycloakUserId: string,
    ): CancelablePromise<UserDetailResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/users/keycloak/{keycloakUserId}',
            path: {
                'keycloakUserId': keycloakUserId,
            },
            errors: {
                404: `Пользователь не найден`,
            },
        });
    }

}
